import { useQuery } from '@tanstack/react-query'
import { QuestionDetailsRes } from '@/types/question.type'
import { axiosInstance } from '@/lib/axios'
import { TypeValue } from '@/features/question-lib/constant'

interface PropsType {
  questionId: string
  questionType: string
  classId?: number | null
}

export const getQuestionDetail = async ({
  questionId,
  questionType,
  classId,
}: PropsType) => {
  const url =
    questionType === TypeValue.case_study ? '/question/case-study' : '/question'

  // Add class_id as query parameter if classId is not null
  const params = classId !== null ? { class_id: classId } : {}

  return axiosInstance.get<QuestionDetailsRes>(`${url}/${questionId}`, {
    params,
  })
}

export const useGetQuestionDetail = ({
  questionId,
  questionType,
  classId,
}: PropsType) => {
  const { data, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ['questionDetai', questionId, questionType, classId],
    queryFn: () => getQuestionDetail({ questionId, questionType, classId }),
    enabled: !!questionId,
  })

  return {
    questionDetail: data?.data,
    isLoadingQuestionDetail: isLoading || isRefetching,
    refetchQuestionDetail: refetch,
  }
}
